<template>
<!-- HISTORY: no-version
   V250917.1: Made the iframe height dynamic and adjustable.
   V250710.1: 1st release.
-->
<v-container fluid class="px-3 py-3">
   <v-card :loading="loading">
      <v-card-text class="pb-0">
         <iframe
            frameborder="0"
            width="100%"
            :height="iframeHeight"
            :src="iframeUrl"
            @load="onIframeLoad"
         ></iframe>
      </v-card-text>
   </v-card>
</v-container>
</template>

<script>
const NAME = "CsMailTracking";

export default {
   name: NAME,

   props: {
      debug: {
         type: Boolean,
         default: false
      },

      isActualEndpoint: {
         type: Boolean,
         default: true
      }
   },

   data() {
      return {
         loading: true,
         iframeHeight: window.innerHeight - 108
      }
   },

   computed: {
      token() {
         return this.$store.getters.token;
      },

      iframeUrl() {
         return process.env.VUE_APP_MAIL_TRACKING_URL + this.token;
      }
   },

   methods: {
      log(msg) {
         if (this.debug)
            console.log(`-----${NAME} V250711.1 says => ${msg}`);
      },

      onIframeLoad() {
         setTimeout(() => {
            // alert('iframe was loaded: url=' + this.iframeUrl);
            this.loading = false;
         }, 10);
      }
   },

   created() { }
}
</script>